module.exports = __webpack_public_path__ + "media/images/1x1-58612301.png";